export enum ERepetition {
	jours = "jours",
	tsLesXJours = "tous les x jours",
	tsLesXMois = "tous les x mois",
	xFoisParMois = "x fois par mois"
}